// Default theme
import { tailwind } from "@theme-ui/presets"

export const theme = {

  // all tailwind styles
  ...tailwind,

  fonts: {
    body: 'Raleway',
    heading: 'Raleway'
  },

  layout: {
    container: {
      mx: "auto",
      p: [4, 4, 5],
      maxWidth: tailwind.breakpoints[3]
    },
  },
  // colors
  colors: {
    ...tailwind.colors,

    primary: tailwind.colors.blue[8],
    primaryHover: tailwind.colors.blue[6],
    secondary: tailwind.colors.orange[6],

    // variants
    success: tailwind.colors.green[3],
    info: tailwind.colors.blue[4],
    warning: tailwind.colors.yellow[3],
    danger: tailwind.colors.red[3],

    text: tailwind.colors.gray[8],

  },

  input: {
    fontFamily: `inherit`
  },

  // global settings
  global: {
    "*": {
      boxSizing: `inherit`,
    },
    body: {
      margin: 0,
      padding: 0,
      boxSizing: `border-box`,
      textRendering: `optimizeLegibility`,
    },
    // "::selection": {
    //   backgroundColor: `primary`,
    //   color: `primary`,
    // },
    a: {
      "textDecoration": `none`,
    },
  },

  buttons: {
      ...tailwind.buttons,
      simple: {
        ...tailwind.buttons.simple,
        fontFamily: `body`,
        fontWeight: `normal`,
        letterSpacing: `wider`,
        textAlign: `center`,
        p: 2
      }
  },

  styles: {


  	...tailwind.styles,

    input: {
      ...tailwind.styles.input,
      fontFamily: `body`
    },

    inverted: {
      h1: {
        variant: `styles.h1`,
        color: `white`
      }, 
      h2: {
        variant: `styles.h2`,
        color: `white`
      }, 
      h3: {
        variant: `styles.h3`,
        color: `white`
      }, 
      h4: {
        variant: `styles.h4`,
        color: `white`
      }, 
      "p": {
        variant: `styles.p`,
        color: `white`
      }
    },

  	h1: {
  		...tailwind.styles.h1,
  		color: `text`,
      fontSize: [4, 5, 6]
  	},

  	h2: {
  		...tailwind.styles.h2,
      color: `text`,
      fontSize: [3, 4, 5]
  	},

  	h3: {
  		...tailwind.styles.h3,
      color: `text`,
      fontSize: [2, 3, 4]
  	},

  	h4: {
  		...tailwind.styles.h4,
      color: `text`,
      fontSize: [1, 2, 3]
  	},

  	p: {
      ...tailwind.styles.p,
      fontFamily: `body`,
      fontWeight: `normal`,
  		fontSize: [0, 1, 2],
      color: `text`,
  		mt: 1
  	},


  	// Heading: {
   //    color: `inherit`,
   //    h1: {
   //      color: `inherit`
   //    },
  	// 	p: {
  	// 		fontSize: [1, 3],
   //      color: `inherit`,
  	// 	}
  	// },



  	// use global styles
  	a: {},

  	Container: {
  		mx: "auto",
  		p: [4, 4, 5],
  		maxWidth: tailwind.breakpoints[3]
  	},

  	Brand: {
  		fontSize: [3, 4],
  		a: {
  			fontWeight: `bold`,
  			borderBottomWidth: `0`,
  			color: `inherit`
  		},
      p: {
        fontWeight: `normal`,
        fontSize: 1,
        m: 0,
        color: `inherit`
      }
  	},

  	Card1: {
  		boxShadow: [`md`,`lg`],
  		background: `white`,
  		borderRadius: `lg`,
      flexDirection: `column`,
      padding: [3, 4],
      p: {
        flex: `1 0 auto`,
        mt: [0, 1]
      },
  		h4: {
  			...tailwind.styles.h4,
  			color: `gray.8`,
  			pb: 2,
  		},
  	},

    Card3: {
      boxShadow: ['default'],
      background: `white`,
      borderRadius: `lg`,
      flexDirection: `column`,
      padding: [0],
      p: {
        flex: `1 0 auto`,
        fontSize: 0,
        mx: 3,
        mt: `0px`,
        color: `gray.5`,
        textTransform: `uppercase`,
        letterSpacing: `wide`
      },
      h4: {
        ...tailwind.styles.h4,
        fontSize: 1,
        color: `gray.6`,
        pt: 2,
        mx: 3,
      },
    },

    Card2: {
      boxShadow: `default`,
      background: `white`,
      borderRadius: `lg`,
      flexDirection: `column`,
      p: {
        flex: `1 0 auto`,
        mt: [0, 1]
      },
      h4: {
        ...tailwind.styles.h4,
        color: `gray.8`,
        pb: 2,
      },     
    },

   // Navigation: {
   //    // py: [1,1,1,3],
   //    // flex: `1`,
   //    a: {
   //        borderBottomWidth: `1px`,
   //        borderBottomStyle: `solid`,
   //        borderBottomColor: `transparent`,
   //        // color: `gray.7`,
   //        // fontSize: 0,
   //        // mx: 3,
   //        textTransform: 'none',
   //        "&:hover": {
   //            color: `primary`,
   //            borderBottomWidth: `1px`,
   //            borderBottomStyle: `solid`,
   //            borderBottomColor: `primary`,
   //        }
   //    }
   //  },

  }

};

export default theme;
